import { useFormSubmit, OnSubmit, UseFormSubmitOptions } from "./useFormSubmit";

export const useFlowFormSubmit = <T>(
  onSubmit: OnSubmit<T>,
  options: UseFormSubmitOptions<T>
) => {
  return useFormSubmit(onSubmit, { ...options, isFlowForm: true });
};
